import React, { useEffect, useState, useMemo, useRef } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";

function ListadoDocumentosSoporte() {
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [documentos, setDocumentos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [cuentasPorPagar, setCuentasPorPagar] = useState([]);
    
    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [usuarioFiltro, setUsuarioFiltro] = useState('');
    const [busquedaProveedor, setBusquedaProveedor] = useState('');
    const [estadoFiltro, setEstadoFiltro] = useState('');
    const [sedeFiltro, setSedeFiltro] = useState('');
    const [sedes, setSedes] = useState([]);
    
    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const registrosPorPagina = 12;
    
    // Modal Debug
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState('');
    
    // Modal Abono
    const [showModalAbono, setShowModalAbono] = useState(false);
    const [documentoAbono, setDocumentoAbono] = useState(null);
    const [valorAbono, setValorAbono] = useState('');
    const [observacionesAbono, setObservacionesAbono] = useState('');
    
    // Modal Anulación
    const [showModalAnulacion, setShowModalAnulacion] = useState(false);
    const [documentoAnular, setDocumentoAnular] = useState(null);
    const [prefijoAnulacion, setPrefijoAnulacion] = useState('');
    const [motivoAnulacion, setMotivoAnulacion] = useState('');
    const [fechaAnulacion, setFechaAnulacion] = useState(new Date().toISOString().split('T')[0]);
    const [prefijosNota, setPrefijosNota] = useState([]);

    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const [documentoAccion, setDocumentoAccion] = useState(null);

    /** true = muestra en el modal de resultado el JSON/respuesta cruda ante la DIAN (solo diagnóstico) */
    const DEBUG_MOSTRAR_JSON_DIAN_EN_MODAL = false;

    const handleAbrirAcciones = (documento) => {
        setDocumentoAccion(documento);
        setShowModalAcciones(true);
    };

    const isMountedRef = useRef(true);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        const hoy = new Date();
        const inicioSemana = new Date(hoy.setDate(hoy.getDate() - hoy.getDay()));
        const finSemana = new Date(hoy.setDate(hoy.getDate() - hoy.getDay() + 6));
        
        setFechaInicio(inicioSemana.toISOString().split('T')[0]);
        setFechaFin(finSemana.toISOString().split('T')[0]);

        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a ver listado de documentos soporte
        const tienePermiso = userdata.up && userdata.up.includes('ver_listado_documentos_soporte');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (!isMountedRef.current) return;
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                if (!isMountedRef.current) return;
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/proveedores?uid=' + userdata.user_id)
            .then(response => {
                if (!isMountedRef.current) return;
                if (response.status === 200) {
                    setProveedores(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/sedes?uid=' + userdata.user_id)
            .then(response => {
                if (!isMountedRef.current) return;
                if (response.status === 200) {
                    setSedes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar cuentas por pagar para mostrar saldos
        cargarCuentasPorPagar();
    }, []);

    const cargarCuentasPorPagar = () => {
        axios.get('/cuentas-por-pagar')
            .then(response => {
                if (!isMountedRef.current) return;
                if (response.status === 200) {
                    setCuentasPorPagar(response.data);
                }
            })
            .catch(error => {
                console.log('Error al cargar cuentas por pagar: ' + error);
            });
    };

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            cargarDocumentos();
        }
    }, [loggedIn, fechaInicio, fechaFin, usuarioFiltro, estadoFiltro, sedeFiltro]);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            const timeoutId = setTimeout(() => {
                cargarDocumentos();
            }, 500);
            return () => clearTimeout(timeoutId);
        }
    }, [busquedaProveedor]);

    const cargarDocumentos = () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas crear config con Authorization

        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (usuarioFiltro) params.append('usuario_id', usuarioFiltro);
        if (busquedaProveedor) params.append('busqueda_proveedor', busquedaProveedor);
        if (estadoFiltro !== '') params.append('estado', estadoFiltro);
        if (sedeFiltro) params.append('sede_id', sedeFiltro);

        // ✅ El interceptor agrega el token automáticamente
        axios.get('/documentos-soporte?' + params.toString())
            .then(response => {
                if (!isMountedRef.current) return;
                if (response.status === 200) {
                    setDocumentos(response.data);
                    cargarCuentasPorPagar();
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    };

    const getNombreProveedor = (proveedorId) => {
        const proveedor = proveedores.find(p => p.id === proveedorId);
        return proveedor ? proveedor.nombre_proveedor : 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id === usuarioId);
        return usuario ? usuario.name : 'N/A';
    };

    const getSaldoPendiente = (documentoId) => {
        const cuenta = cuentasPorPagar.find(c => c.documento_soporte_id === documentoId);
        return cuenta ? parseFloat(cuenta.valor_pendiente || 0) : 0;
    };

    const getTipoPagoTexto = (tipoPago) => {
        switch(tipoPago) {
            case 'pagada': return 'Pagada';
            case 'por_pagar': return 'Por Pagar';
            default: return 'Pagada'; // Default para documentos antiguos
        }
    };

    const getEstadoTexto = (estado) => {
        switch(estado) {
            case 0: return 'Generado';
            case 1: return 'Enviado DIAN';
            case 2: return 'Anulado';
            case 3: return 'Error DIAN';
            default: return 'Desconocido';
        }
    };

    const pillBase = { borderRadius: '10px', fontWeight: 700, fontSize: '0.7rem', padding: '6px 10px', display: 'inline-block' };
    const getEstadoDianPillStyle = (estado) => {
        const e = parseInt(estado, 10);
        if (e === 0) return { ...pillBase, background: 'rgba(108,117,125,0.1)', color: '#6c757d', border: '1px solid rgba(108,117,125,0.25)' };
        if (e === 1) return { ...pillBase, background: 'rgba(40,167,69,0.1)', color: '#28a745', border: '1px solid rgba(40,167,69,0.25)' };
        if (e === 2) return { ...pillBase, background: 'rgba(220,53,69,0.1)', color: '#dc3545', border: '1px solid rgba(220,53,69,0.25)' };
        if (e === 3) return { ...pillBase, background: 'rgba(220,53,69,0.12)', color: '#c0392b', border: '1px solid rgba(220,53,69,0.28)' };
        return { ...pillBase, background: 'rgba(108,117,125,0.1)', color: '#6c757d', border: '1px solid rgba(108,117,125,0.25)' };
    };
    const getTipoPagoPillStyle = (tipoPago) => {
        if (tipoPago === 'por_pagar') return { ...pillBase, background: 'rgba(255,193,7,0.12)', color: '#b8860b', border: '1px solid rgba(255,193,7,0.35)' };
        return { ...pillBase, background: 'rgba(40,167,69,0.1)', color: '#28a745', border: '1px solid rgba(40,167,69,0.25)' };
    };

    /** Estado DIAN anulado (2): no mostrar «Pagada» aunque el campo tipo_pago siga en pagada */
    const getEstadoPagoPillForDocumento = (documento) => {
        const estDian = parseInt(documento.estado, 10);
        if (estDian === 2) {
            return {
                texto: 'No aplica',
                style: { ...pillBase, background: 'rgba(108,117,125,0.1)', color: '#5a6268', border: '1px solid rgba(108,117,125,0.28)' }
            };
        }
        const tipo = documento.tipo_pago || 'pagada';
        return { texto: getTipoPagoTexto(tipo), style: getTipoPagoPillStyle(tipo) };
    };

    const documentoDianActivo = (documento) => {
        if (!documento) return false;
        return parseInt(documento.estado, 10) !== 2;
    };

    const abrirModalAbono = (documento) => {
        const saldoPendiente = getSaldoPendiente(documento.id);
        
        if (saldoPendiente <= 0) {
            alert('Este documento no tiene saldo pendiente por pagar.');
            return;
        }

        setDocumentoAbono(documento);
        setValorAbono('');
        setObservacionesAbono('');
        setShowModalAbono(true);
    };

    const realizarAbono = async () => {
        if (!valorAbono || parseFloat(valorAbono) <= 0) {
            alert('Por favor ingrese un valor válido para el abono.');
            return;
        }

        const saldoPendiente = getSaldoPendiente(documentoAbono.id);
        const montoAbono = parseFloat(valorAbono);

        if (montoAbono > saldoPendiente) {
            alert(`El abono no puede ser mayor al saldo pendiente ($${saldoPendiente.toLocaleString('es-CO')})`);
            return;
        }

        if (!window.confirm(`¿Está seguro de realizar un abono de $${montoAbono.toLocaleString('es-CO')}?`)) {
            return;
        }

        try {
            // Buscar la cuenta por pagar correspondiente
            const cuenta = cuentasPorPagar.find(c => c.documento_soporte_id === documentoAbono.id);
            
            if (!cuenta) {
                alert('No se encontró la cuenta por pagar para este documento.');
                return;
            }

            const response = await axios.post(`/cuenta-por-pagar/${cuenta.id}/abono`, {
                valor_abono: montoAbono,
                observaciones: observacionesAbono
            });
            
            if (response.status === 200 || response.status === 201) {
                const mensaje = response.data.estado === 'Pagada' 
                    ? `Abono de $${montoAbono.toLocaleString('es-CO')} realizado exitosamente.\nDocumento COMPLETAMENTE PAGADO.\nEgreso N° ${response.data.numero_egreso} generado.`
                    : `Abono de $${montoAbono.toLocaleString('es-CO')} realizado exitosamente.\nSaldo pendiente: $${response.data.saldo_pendiente.toLocaleString('es-CO')}\nEgreso N° ${response.data.numero_egreso} generado.`;
                
                alert(mensaje);
                setShowModalAbono(false);
                cargarDocumentos();
                cargarCuentasPorPagar();
            }
        } catch (error) {
            console.error('Error al realizar abono:', error);
            alert('Error al realizar abono: ' + (error.response?.data?.message || error.message));
        }
    };

    const abrirModalAnulacion = async (documento) => {
        setDocumentoAnular(documento);
        
        // Estado generado (0) o error DIAN (3): anulación en sistema sin nota electrónica (backend anulacion-provisional)
        const estAnulSimple = parseInt(documento.estado, 10);
        if (estAnulSimple === 0 || estAnulSimple === 3) {
            const msgSimple =
                estAnulSimple === 3
                    ? '¿Anular este documento soporte? Está en «Error DIAN» (no aceptado por la DIAN). Se marcará como anulado solo en el sistema, sin nota electrónica de anulación.'
                    : '¿Anular este documento soporte? No ha sido enviado a la DIAN; se marcará como anulado en el sistema sin nota electrónica.';
            if (!window.confirm(msgSimple)) {
                return;
            }

            try {
                const response = await axios.post(`/documento-soporte/${documento.id}/anulacion-provisional`, {});

                if (response.status === 200) {
                    alert('Documento soporte anulado correctamente.');
                    cargarDocumentos();
                }
            } catch (error) {
                alert('Error al anular el documento: ' + (error.response?.data?.message || error.message));
            }
            return;
        }

        // Si está enviado a DIAN (estado 1), cargar prefijos y mostrar modal
        if (parseInt(documento.estado, 10) === 1) {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

            try {
                const response = await axios.get('/parametros-fev?uid=' + userdata.user_id);
                if (response.status === 200) {
                    const prefijosFiltrados = response.data.filter(p => 
                        p.tipo === 'Nota Documento Soporte' && 
                        p.estado == 1
                    );
                    setPrefijosNota(prefijosFiltrados);
                    setShowModalAnulacion(true);
                }
            } catch (error) {
                alert('Error al cargar prefijos: ' + error.message);
            }
        } else {
            alert('Solo se pueden anular documentos en estado Generado, Error DIAN o Enviado a DIAN');
        }
    };

    const generarNotaAnulacion = async () => {
        if (!prefijoAnulacion) {
            alert('Por favor seleccione un prefijo');
            return;
        }

        if (!fechaAnulacion) {
            alert('Por favor seleccione una fecha');
            return;
        }

        if (!window.confirm('¿Está seguro de generar una Nota de Documento Soporte para anular? Esta acción no se puede deshacer.')) {
            return;
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        try {
            // Enviar directamente a DIAN (sin crear nota primero)
            const envioResponse = await axios.post('/nota-documento-soporte/enviar-dian-directo', {
                documento_soporte_id: documentoAnular.id,
                parametrosfev_id: parseInt(prefijoAnulacion),
                motivo_observacion: motivoAnulacion || 'Anulación de documento soporte',
                fecha_emision: fechaAnulacion
            });
            
            setShowModalAnulacion(false);
            
            if (envioResponse.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Nota de documento soporte enviada exitosamente a la DIAN',
                    cufe: envioResponse.data.uuid
                });
                setShowModalDebug(true);
            } else {
                setDebugType('error');
                setDebugData({
                    message: envioResponse.data.message,
                    response: envioResponse.data.response,
                    json_enviado: envioResponse.data.json_enviado,
                    status_code: envioResponse.data.status_code
                });
                setShowModalDebug(true);
            }
            
            cargarDocumentos();
            setPrefijoAnulacion('');
            setMotivoAnulacion('');
            setFechaAnulacion(new Date().toISOString().split('T')[0]);
            
        } catch (error) {
            console.error('Error al enviar nota a DIAN:', error);
            setShowModalAnulacion(false);
            
            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data
            });
            setShowModalDebug(true);
        }
    };

    const enviarDian = async (documentoId) => {
        if (!window.confirm('¿Está seguro de enviar este documento a la DIAN?')) {
            return;
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        try {
            const response = await axios.post(`/documento-soporte/${documentoId}/enviar-dian`, {});
            
            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Documento soporte enviado exitosamente a la DIAN',
                    cufe: response.data.uuid,
                    estado: response.data.estado,
                    documentoId: documentoId
                });
                setShowModalDebug(true);
                cargarDocumentos();
            } else {
                setDebugType('error');
                setDebugData({
                    message: response.data.message,
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    documentoId: documentoId
                });
                setShowModalDebug(true);
            }
        } catch (error) {
            console.error('Error al enviar a DIAN:', error);
            
            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data,
                documentoId: documentoId
            });
            setShowModalDebug(true);
        }
    };

    const generarEgresoDesdeListado = async (documentoId) => {
        if (!window.confirm('¿Está seguro de generar un egreso para cancelar esta cuenta por pagar?')) {
            return;
        }

        try {
            const response = await axios.post('/documento-soporte/generar-egreso', {
                documento_soporte_id: documentoId
            });
            
            if (response.status === 200 || response.status === 201) {
                alert(`Egreso N° ${response.data.numero_egreso} generado exitosamente.\nDocumento marcado como PAGADA.`);
                cargarDocumentos();
            }
        } catch (error) {
            console.error('Error al generar egreso:', error);
            alert('Error al generar egreso: ' + (error.response?.data?.message || error.message));
        }
    };

    const indiceUltimoRegistro = paginaActual * registrosPorPagina;
    const indicePrimerRegistro = indiceUltimoRegistro - registrosPorPagina;
    const documentosPaginados = documentos.slice(indicePrimerRegistro, indiceUltimoRegistro);
    const totalPaginas = Math.ceil(documentos.length / registrosPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
        setShowModalAcciones(false);
        setDocumentoAccion(null);
    };

    useEffect(() => {
        setPaginaActual(1);
    }, [fechaInicio, fechaFin, usuarioFiltro, estadoFiltro, sedeFiltro, busquedaProveedor]);

    const getPaginationItems = (current, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
        if (current <= 3) return [1, 2, 3, 4, null, total];
        if (current >= total - 2) return [1, null, total - 3, total - 2, total - 1, total];
        return [1, null, current - 1, current, current + 1, null, total];
    };

    const totalesDoc = useMemo(() => {
        let valor = 0;
        let pendiente = 0;
        let enviadosDian = 0;
        documentos.forEach(d => {
            valor += parseFloat(d.valor_total || 0);
            if (parseInt(d.estado, 10) !== 2 && d.tipo_pago === 'por_pagar') {
                const cuenta = cuentasPorPagar.find(c => c.documento_soporte_id === d.id);
                pendiente += cuenta ? parseFloat(cuenta.valor_pendiente || 0) : 0;
            }
            if (parseInt(d.estado, 10) === 1) enviadosDian++;
        });
        return { conteo: documentos.length, valor, pendiente, enviadosDian };
    }, [documentos, cuentasPorPagar]);

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <style>{`
                    .summary-card { background: #fff; padding: 1.25rem; border-radius: 12px; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); border: none; transition: transform 0.2s; height: 100%; }
                    .summary-card:hover { transform: translateY(-3px); }
                    .icon-box { width: 45px; height: 45px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; margin-right: 15px; }
                    .card-label { color: #8c8c8c; font-size: 0.75rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
                    .card-value { font-size: 1.25rem; font-weight: 700; color: #323a45; }
                    .card-subtext { font-size: 0.65rem; color: #bababa; margin-top: 2px; }
                    .filter-card { background: #fff; border-radius: 12px; border: none; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.05); }
                    .custom-table { width: 100%; background: #fff; border-radius: 12px; overflow: hidden; }
                    .custom-table thead th {
                        background: #f8f9fa; color: #7d7d7d !important; text-transform: uppercase; font-size: 0.7rem !important;
                        font-weight: 700 !important; padding: 12px 15px !important; border: none !important;
                    }
                    .custom-table tbody tr { border-bottom: 1px solid #f0f0f0; transition: all 0.2s; cursor: default; }
                    .custom-table tbody tr:hover { background-color: #f9fbff !important; box-shadow: inset 4px 0 0 #17a2b8; }
                    .custom-table td { padding: 10px 15px !important; vertical-align: middle !important; border: none !important; font-size: 0.8rem !important; }
                    .lds-ds-modal .modal-content {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.08) !important;
                        box-shadow: 0 12px 32px rgba(0,0,0,0.08) !important;
                        overflow: hidden;
                    }
                    .lds-ds-modal .modal-header.lds-ds-modal-head {
                        background: #f8f9fa !important;
                        border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                    }
                    .lds-ds-modal .modal-header.lds-ds-modal-head .modal-title {
                        font-size: 1rem;
                        font-weight: 700;
                        color: #323a45;
                    }
                    .lds-ds-modal .modal-header.lds-ds-modal-head .close {
                        color: #323a45;
                        opacity: 0.65;
                        text-shadow: none;
                    }
                    .lds-ds-alert-info-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(23, 162, 184, 0.28);
                        background: rgba(23, 162, 184, 0.09);
                        color: #0c5460;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                    }
                    .lds-ds-alert-caution-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(212, 167, 44, 0.35);
                        background: linear-gradient(180deg, #fffdf8 0%, #fff8ec 100%);
                        color: #5c4508;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                    }
                    .lds-ds-alert-success-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(40, 167, 69, 0.32);
                        background: rgba(40, 167, 69, 0.09);
                        color: #155724;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                    }
                    .lds-ds-alert-danger-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(220, 53, 69, 0.28);
                        background: rgba(220, 53, 69, 0.07);
                        color: #7a1e26;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                    }
                    .lds-ds-debug-pre {
                        background: #f8f9fa;
                        padding: 12px 14px;
                        border-radius: 10px;
                        max-height: 360px;
                        overflow: auto;
                        font-size: 11px;
                        white-space: pre-wrap;
                        word-break: break-word;
                        border: 1px solid rgba(0,0,0,0.06);
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item active">Listado de Documentos Soporte</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-center">
                                <div className="col-sm-12 col-md-8">
                                    <h1 className="m-0" style={{ fontWeight: 700, fontSize: '1.5rem', color: '#323a45' }}>Listado de Documentos Soporte</h1>
                                    <p className="mb-0 mt-1 text-muted" style={{ fontSize: '0.8rem' }}>
                                        <span className="badge" style={{ background: 'rgba(23,162,184,0.1)', color: '#117f90', border: '1px solid rgba(23,162,184,0.2)', borderRadius: '999px', fontWeight: 700, fontSize: '0.72rem' }}>{documentos.length} registros</span>
                                    </p>
                                </div>
                                <div className="col-sm-12 col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/crear-documento-soporte" className="btn btn-primary" style={{ borderRadius: '10px', padding: '7px 18px', fontSize: '0.9rem' }}>
                                        <i className="fas fa-plus mr-2"></i> Nuevo Documento Soporte
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">

                            <div className="row mb-4">
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{ background: 'rgb(240, 245, 255)', color: 'rgb(123 136 145)' }}><i className="fas fa-file-invoice"></i></div>
                                        <div><div className="card-label">Documentos</div><div className="card-value">{totalesDoc.conteo}</div><div className="card-subtext">En el periodo filtrado</div></div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{ background: 'rgb(230, 247, 255)', color: '#17a2b8' }}><i className="fas fa-dollar-sign"></i></div>
                                        <div><div className="card-label">Valor total</div><div className="card-value">${Math.round(totalesDoc.valor).toLocaleString('es-CO')}</div><div className="card-subtext">Suma de totales</div></div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{ background: '#fff7e6', color: '#faad14' }}><i className="fas fa-hourglass-half"></i></div>
                                        <div><div className="card-label">Por pagar</div><div className="card-value">${Math.round(totalesDoc.pendiente).toLocaleString('es-CO')}</div><div className="card-subtext">Saldo pendiente</div></div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{ background: '#f6ffed', color: '#52c41a' }}><i className="fas fa-paper-plane"></i></div>
                                        <div><div className="card-label">Enviados DIAN</div><div className="card-value">{totalesDoc.enviadosDian}</div><div className="card-subtext">Estado enviado</div></div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Filtros */}
                            <div className="filter-card p-4 mb-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="small font-weight-bold text-uppercase text-muted d-block">Fecha Inicio</label>
                                        <input type="date" className="form-control" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="small font-weight-bold text-uppercase text-muted d-block">Fecha Fin</label>
                                        <input type="date" className="form-control" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="small font-weight-bold text-uppercase text-muted d-block">Usuario</label>
                                        <select className="form-control" value={usuarioFiltro} onChange={(e) => setUsuarioFiltro(e.target.value)}>
                                            <option value="">Todos</option>
                                            {usuarios.map(usuario => (
                                                <option key={usuario.id} value={usuario.id}>{usuario.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="small font-weight-bold text-uppercase text-muted d-block">Estado</label>
                                        <select className="form-control" value={estadoFiltro} onChange={(e) => setEstadoFiltro(e.target.value)}>
                                            <option value="">Todos</option>
                                            <option value="0">Generado</option>
                                            <option value="1">Enviado DIAN</option>
                                            <option value="2">Anulado</option>
                                            <option value="3">Error DIAN</option>
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="small font-weight-bold text-uppercase text-muted d-block">Sede</label>
                                        <select className="form-control" value={sedeFiltro} onChange={(e) => setSedeFiltro(e.target.value)}>
                                            <option value="">Todas</option>
                                            {sedes.map(sede => (
                                                <option key={sede.id} value={sede.id}>{sede.nombre}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="small font-weight-bold text-uppercase text-muted d-block">Buscar Proveedor</label>
                                        <input type="text" className="form-control" placeholder="Nombre..." value={busquedaProveedor} onChange={(e) => setBusquedaProveedor(e.target.value)} />
                                    </div>
                                </div>
                            </div>

                            {/* Tabla de documentos */}
                            <div className="card shadow-sm border-0" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                                <div className="card-body p-0" style={{ overflowX: 'auto', minHeight: '280px' }}>
                                    <table className="table custom-table mb-0" style={{ minWidth: '980px' }}>
                                        <thead>
                                            <tr>
                                                <th>N° Documento</th>
                                                <th>Fecha</th>
                                                <th>Proveedor</th>
                                                <th>Usuario</th>
                                                <th className="text-right">Total</th>
                                                <th className="text-right">Saldo pendiente</th>
                                                <th className="text-center">Estado pago</th>
                                                <th className="text-center">Estado</th>
                                                <th className="text-center" width="80">ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {documentosPaginados.map(documento => {
                                                const estadoPagoPill = getEstadoPagoPillForDocumento(documento);
                                                return (
                                                <tr key={documento.id}>
                                                    <td>
                                                        <strong>{documento.prefijo}-{documento.numero}</strong>
                                                    </td>
                                                    <td>{new Date(documento.fecha_emision).toLocaleDateString()}</td>
                                                    <td>
                                                        <span title={getNombreProveedor(documento.proveedor_id)}>
                                                            {getNombreProveedor(documento.proveedor_id).length > 25 
                                                                ? getNombreProveedor(documento.proveedor_id).substring(0, 25) + '...' 
                                                                : getNombreProveedor(documento.proveedor_id)
                                                            }
                                                        </span>
                                                    </td>
                                                    <td>{getNombreUsuario(documento.users_id)}</td>
                                                    <td className="text-right">
                                                        <strong>${Math.round(parseFloat(documento.valor_total)).toLocaleString('es-CO')}</strong>
                                                    </td>
                                                    <td className="text-right">
                                                        {parseInt(documento.estado, 10) === 2 ? (
                                                            <span className="text-muted"><strong>—</strong></span>
                                                        ) : documento.tipo_pago === 'por_pagar' ? (
                                                            <span className="text-danger">
                                                                <strong>${Math.round(getSaldoPendiente(documento.id)).toLocaleString('es-CO')}</strong>
                                                            </span>
                                                        ) : (
                                                            <span className="text-success">
                                                                <strong>$0</strong>
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        <span style={estadoPagoPill.style}>{estadoPagoPill.texto}</span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span style={getEstadoDianPillStyle(documento.estado)}>
                                                            {getEstadoTexto(documento.estado)}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light border"
                                                            style={{ borderRadius: '8px' }}
                                                            title="Acciones"
                                                            onClick={() => handleAbrirAcciones(documento)}
                                                        >
                                                            <i className="fas fa-ellipsis-v"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                            })}
                                        </tbody>
                                    </table>
                                    {documentos.length === 0 && (
                                        <div className="text-center p-4 text-muted">
                                            <p className="mb-0">No se encontraron documentos soporte para los filtros seleccionados.</p>
                                        </div>
                                    )}
                                </div>

                                <div className="card-footer bg-white border-0 py-3">
                                    <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: '12px' }}>
                                        <div style={{ color: '#8c8c8c', fontSize: '0.8rem', flex: '1 1 auto' }}>
                                            Mostrando <strong>{documentos.length === 0 ? 0 : indicePrimerRegistro + 1}</strong> a <strong>{Math.min(indiceUltimoRegistro, documentos.length)}</strong> de <strong>{documentos.length}</strong> documentos
                                        </div>
                                        <nav>
                                            <ul className="pagination pagination-sm mb-0" style={{ gap: '5px' }}>
                                                <li className={`page-item ${paginaActual === 1 || totalPaginas === 0 ? 'disabled' : ''}`}>
                                                    <button type="button" className="page-link border-0 shadow-sm" onClick={() => cambiarPagina(paginaActual - 1)} disabled={paginaActual === 1 || totalPaginas === 0} style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}>
                                                        <i className="fas fa-chevron-left"></i>
                                                    </button>
                                                </li>
                                                {totalPaginas < 1 ? (
                                                    <li className="page-item disabled">
                                                        <span className="page-link border-0 shadow-sm" style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#8c8c8c' }}>1</span>
                                                    </li>
                                                ) : (
                                                    getPaginationItems(paginaActual, totalPaginas).map((item, idx) => {
                                                        if (item === null) {
                                                            return (
                                                                <li key={`ellipsis-${idx}`} className="page-item disabled">
                                                                    <span className="page-link border-0 shadow-sm" style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#8c8c8c' }}>...</span>
                                                                </li>
                                                            );
                                                        }
                                                        return (
                                                            <li key={item} className={`page-item ${paginaActual === item ? 'active' : ''}`}>
                                                                <button
                                                                    type="button"
                                                                    className="page-link border-0 shadow-sm"
                                                                    onClick={() => cambiarPagina(item)}
                                                                    style={{
                                                                        borderRadius: '8px',
                                                                        padding: '6px 12px',
                                                                        background: paginaActual === item ? '#17a2b8' : '#f8f9fa',
                                                                        color: paginaActual === item ? 'white' : '#323a45',
                                                                        fontWeight: 700,
                                                                        border: 0
                                                                    }}
                                                                >
                                                                    {item}
                                                                </button>
                                                            </li>
                                                        );
                                                    })
                                                )}
                                                <li className={`page-item ${paginaActual === totalPaginas || totalPaginas === 0 ? 'disabled' : ''}`}>
                                                    <button type="button" className="page-link border-0 shadow-sm" onClick={() => cambiarPagina(paginaActual + 1)} disabled={paginaActual === totalPaginas || totalPaginas === 0} style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}>
                                                        <i className="fas fa-chevron-right"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal de acciones por fila (información, abono, DIAN, etc.) */}
                {showModalAcciones && documentoAccion && (
                    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 9999 }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                                <div className="modal-header border-0 pb-0" style={{ background: '#f8f9fa' }}>
                                    <h6 className="modal-title font-weight-bold small mb-0 pr-2">
                                        OPCIONES N° {documentoAccion.prefijo}-{documentoAccion.numero}
                                    </h6>
                                    <button type="button" className="close" onClick={() => { setShowModalAcciones(false); setDocumentoAccion(null); }} aria-label="Cerrar">
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body p-3">
                                    <div className="list-group list-group-flush">
                                        <button
                                            type="button"
                                            className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                            style={{ borderRadius: '12px', background: 'rgba(23, 162, 184, 0.05)' }}
                                            onClick={() => {
                                                history.push(`/informacion-documento-soporte/${documentoAccion.id}`);
                                                setShowModalAcciones(false);
                                                setDocumentoAccion(null);
                                            }}
                                        >
                                            <i className="fas fa-info-circle mr-2 text-info"></i> Información
                                        </button>

                                        {documentoDianActivo(documentoAccion) && documentoAccion.tipo_pago === 'por_pagar' && getSaldoPendiente(documentoAccion.id) > 0 && (
                                            <>
                                                <button
                                                    type="button"
                                                    className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                    style={{ borderRadius: '12px' }}
                                                    onClick={() => {
                                                        abrirModalAbono(documentoAccion);
                                                        setShowModalAcciones(false);
                                                        setDocumentoAccion(null);
                                                    }}
                                                >
                                                    <i className="fas fa-coins mr-2 text-primary"></i> Realizar abono
                                                </button>
                                                <button
                                                    type="button"
                                                    className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                    style={{ borderRadius: '12px' }}
                                                    onClick={() => {
                                                        generarEgresoDesdeListado(documentoAccion.id);
                                                        setShowModalAcciones(false);
                                                        setDocumentoAccion(null);
                                                    }}
                                                >
                                                    <i className="fas fa-money-bill-wave mr-2 text-primary"></i> Pagar todo
                                                </button>
                                            </>
                                        )}

                                        {parseInt(documentoAccion.estado, 10) === 0 && (
                                            <>
                                                <button
                                                    type="button"
                                                    className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                    style={{ borderRadius: '12px' }}
                                                    onClick={() => {
                                                        abrirModalAnulacion(documentoAccion);
                                                        setShowModalAcciones(false);
                                                        setDocumentoAccion(null);
                                                    }}
                                                >
                                                    <i className="fas fa-ban mr-2 text-danger"></i> Anular
                                                </button>
                                                <button
                                                    type="button"
                                                    className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                    style={{ borderRadius: '12px' }}
                                                    onClick={() => {
                                                        enviarDian(documentoAccion.id);
                                                        setShowModalAcciones(false);
                                                        setDocumentoAccion(null);
                                                    }}
                                                >
                                                    <i className="fas fa-paper-plane mr-2 text-primary"></i> Enviar a DIAN
                                                </button>
                                            </>
                                        )}

                                        {parseInt(documentoAccion.estado, 10) === 1 && (
                                            <button
                                                type="button"
                                                className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                style={{ borderRadius: '12px' }}
                                                onClick={() => {
                                                    abrirModalAnulacion(documentoAccion);
                                                    setShowModalAcciones(false);
                                                    setDocumentoAccion(null);
                                                }}
                                            >
                                                <i className="fas fa-file-invoice mr-2 text-danger"></i> Nota anulación
                                            </button>
                                        )}

                                        {parseInt(documentoAccion.estado, 10) === 3 && (
                                            <>
                                                <button
                                                    type="button"
                                                    className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                    style={{ borderRadius: '12px' }}
                                                    onClick={() => {
                                                        abrirModalAnulacion(documentoAccion);
                                                        setShowModalAcciones(false);
                                                        setDocumentoAccion(null);
                                                    }}
                                                >
                                                    <i className="fas fa-ban mr-2 text-danger"></i> Anular
                                                </button>
                                                <button
                                                    type="button"
                                                    className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                    style={{ borderRadius: '12px' }}
                                                    onClick={() => {
                                                        enviarDian(documentoAccion.id);
                                                        setShowModalAcciones(false);
                                                        setDocumentoAccion(null);
                                                    }}
                                                >
                                                    <i className="fas fa-redo mr-2 text-primary"></i> Enviar a DIAN
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Anulación */}
                {showModalAnulacion && (
                    <div className="modal fade show lds-ds-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1055 }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header lds-ds-modal-head">
                                    <h5 className="modal-title mb-0">
                                        <i className="fas fa-file-invoice mr-2 text-info"></i>
                                        Nota de anulación — documento soporte
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalAnulacion(false)} aria-label="Cerrar">
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="lds-ds-alert-caution-soft mb-3">
                                        <i className="fas fa-info-circle mr-2 text-warning" style={{ opacity: 0.85 }}></i>
                                        Esta acción generará una nota de documento soporte y anulará el documento original ante la DIAN.
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Documento a Anular</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            value={documentoAnular ? `${documentoAnular.prefijo}${documentoAnular.numero}` : ''}
                                            readOnly
                                        />
                                    </div>
                                    
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Prefijo Nota *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={prefijoAnulacion}
                                                    onChange={(e) => setPrefijoAnulacion(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {prefijosNota.map(p => (
                                                        <option key={p.id} value={p.id}>{p.prefijo}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>N° Nota</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={prefijosNota.find(p => p.id == prefijoAnulacion)?.numero_factura || ''}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Fecha Anulación *</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fechaAnulacion}
                                                    onChange={(e) => setFechaAnulacion(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Motivo de Anulación</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            value={motivoAnulacion}
                                            onChange={(e) => setMotivoAnulacion(e.target.value)}
                                            placeholder="Ingrese el motivo de la anulación..."
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="modal-footer border-top bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalAnulacion(false)}>Cancelar</button>
                                    <button type="button" className="btn btn-info" onClick={generarNotaAnulacion}>
                                        <i className="fas fa-paper-plane mr-1"></i> Generar nota y enviar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal resultado envío / nota anulación (mismo estilo que resto de modales del listado) */}
                {showModalDebug && (
                    <div className="modal fade show lds-ds-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1060 }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header lds-ds-modal-head">
                                    <h5 className="modal-title mb-0">
                                        {debugType === 'success' ? (
                                            <><i className="fas fa-check-circle mr-2 text-success"></i>Envío exitoso</>
                                        ) : (
                                            <><i className="fas fa-exclamation-circle mr-2 text-danger" style={{ opacity: 0.88 }}></i>Error en el envío</>
                                        )}
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalDebug(false)} aria-label="Cerrar">
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {debugType === 'success' ? (
                                        <div>
                                            <div className="lds-ds-alert-success-soft mb-3">
                                                <strong>{debugData?.message}</strong>
                                            </div>
                                            <div className="lds-ds-alert-info-soft mb-0">
                                                <p className="mb-1"><strong>CUFE / UUID:</strong>{' '}
                                                    <code style={{ fontSize: '0.85em', color: '#0c5460' }}>{debugData?.cufe || '—'}</code>
                                                </p>
                                                <p className="mb-0"><strong>Estado:</strong>{' '}
                                                    <span style={{ ...pillBase, background: 'rgba(40,167,69,0.1)', color: '#28a745', border: '1px solid rgba(40,167,69,0.25)' }}>Enviado a DIAN</span>
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="lds-ds-alert-danger-soft mb-0">
                                                <strong>{debugData?.message || 'No se pudo completar la operación.'}</strong>
                                            </div>

                                            {DEBUG_MOSTRAR_JSON_DIAN_EN_MODAL && debugData?.response && (
                                                <div className="mt-3">
                                                    <div className="small font-weight-bold text-uppercase text-muted mb-2">Respuesta DIAN (debug)</div>
                                                    <pre className="lds-ds-debug-pre mb-0">{JSON.stringify(debugData.response, null, 2)}</pre>
                                                </div>
                                            )}

                                            {DEBUG_MOSTRAR_JSON_DIAN_EN_MODAL && debugData?.json_enviado && (
                                                <div className="mt-3">
                                                    <div className="small font-weight-bold text-uppercase text-muted mb-2">JSON enviado (debug)</div>
                                                    <pre className="lds-ds-debug-pre mb-0">{JSON.stringify(debugData.json_enviado, null, 2)}</pre>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer border-top bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Abono */}
                {showModalAbono && (
                    <div className="modal fade show lds-ds-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1055 }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header lds-ds-modal-head">
                                    <h5 className="modal-title mb-0">
                                        <i className="fas fa-coins mr-2 text-info"></i>
                                        Realizar abono
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalAbono(false)} aria-label="Cerrar">
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="lds-ds-alert-info-soft mb-3">
                                        <i className="fas fa-info-circle mr-2"></i>
                                        Puede registrar abonos parciales desde $1 hasta el saldo pendiente.
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Documento</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            value={documentoAbono ? `${documentoAbono.prefijo}-${documentoAbono.numero}` : ''}
                                            readOnly
                                        />
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Valor Total</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={documentoAbono ? `$${Math.round(parseFloat(documentoAbono.valor_total)).toLocaleString('es-CO')}` : ''}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Saldo Pendiente</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control font-weight-bold"
                                                    style={{ color: '#b8860b', background: 'rgba(255, 193, 7, 0.06)', borderColor: 'rgba(212, 167, 44, 0.35)' }}
                                                    value={documentoAbono ? `$${Math.round(getSaldoPendiente(documentoAbono.id)).toLocaleString('es-CO')}` : ''}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Valor del Abono *</label>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">$</span>
                                            </div>
                                            <input 
                                                type="number" 
                                                className="form-control" 
                                                placeholder="Ingrese el valor del abono"
                                                value={valorAbono}
                                                onChange={(e) => setValorAbono(e.target.value)}
                                                min="1"
                                                max={documentoAbono ? getSaldoPendiente(documentoAbono.id) : 0}
                                                step="0.01"
                                                required
                                            />
                                        </div>
                                        <small className="form-text text-muted">
                                            Mínimo: $1 - Máximo: ${documentoAbono ? Math.round(getSaldoPendiente(documentoAbono.id)).toLocaleString('es-CO') : 0}
                                        </small>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Observaciones</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            value={observacionesAbono}
                                            onChange={(e) => setObservacionesAbono(e.target.value)}
                                            placeholder="Observaciones del abono (opcional)..."
                                        ></textarea>
                                    </div>

                                    {valorAbono && parseFloat(valorAbono) > 0 && (
                                        <div className="lds-ds-alert-success-soft mb-0">
                                            <strong>Resumen</strong><br />
                                            Valor a abonar: <strong>${parseFloat(valorAbono).toLocaleString('es-CO')}</strong><br />
                                            Saldo después del abono: <strong>${(getSaldoPendiente(documentoAbono?.id || 0) - parseFloat(valorAbono)).toLocaleString('es-CO')}</strong><br />
                                            Se generará un <strong>egreso automático</strong>.
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer border-top bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalAbono(false)}>
                                        Cancelar
                                    </button>
                                    <button 
                                        type="button" 
                                        className="btn btn-info" 
                                        onClick={realizarAbono}
                                        disabled={!valorAbono || parseFloat(valorAbono) <= 0}
                                    >
                                        <i className="fas fa-coins mr-1"></i> Realizar abono
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default ListadoDocumentosSoporte;
